import { gsap } from 'gsap';

export function buttonRoundedInit(el) {
  const content = el.querySelector('p');

  gsap.set(el, { scale: 0, transformOrigin: '50% 50%' });
  gsap.set(content, { opacity: 0, translateY: 20 });
}

export function buttonRoundedEnter(el) {
  const content = el.querySelector('p');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, {
      scale: 1,
      ease: 'flap',
    }, 'start')
    .to(content, {
      opacity: 1,
      translateY: 0,
      duration: 0.5,
      ease: 'flap',
    }, 'start+=0.2');

  return tl;
}

export function buttonRoundedLeave(el) {
  const content = el.querySelector('p');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(content, {
      opacity: 0,
      translateY: 20,
      duration: 0.7,
      ease: 'flap',
    }, 'start')
    .to(el, {
      scale: 0,
      ease: 'flap',
    }, 'start+=0.1');

  return tl;
}
